export const formatPersonShortName = (fullName) => {
  const parts = String(fullName || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '—';
  if (parts.length === 1) return parts[0];
  const first = parts[0];
  const lastInitial = parts[parts.length - 1].charAt(0).toUpperCase();
  return `${first} ${lastInitial}.`;
};

export const WEEKDAY_OPTIONS = [
  { value: 1, label: 'Lundi', short: 'Lun' },
  { value: 2, label: 'Mardi', short: 'Mar' },
  { value: 3, label: 'Mercredi', short: 'Mer' },
  { value: 4, label: 'Jeudi', short: 'Jeu' },
  { value: 5, label: 'Vendredi', short: 'Ven' },
  { value: 6, label: 'Samedi', short: 'Sam' },
  { value: 7, label: 'Dimanche', short: 'Dim' },
];

export const CANAUX_OPTIONS = [
  { id: 'mag', label: 'Magazine', icon: 'mdi:newspaper-variant-outline', color: '#e30613' },
  { id: 'set', label: 'SET', icon: 'mdi:calendar-month-outline', color: '#2563eb' },
  { id: 'web', label: 'WEB', icon: 'mdi:web', color: '#059669' },
  { id: 'newsletter', label: 'Newsletter', icon: 'mdi:email-newsletter', color: '#7c3aed' },
];

export const MOIS_OPTIONS = [
  { value: 1, label: 'Janvier' }, { value: 2, label: 'Février' }, { value: 3, label: 'Mars' },
  { value: 4, label: 'Avril' }, { value: 5, label: 'Mai' }, { value: 6, label: 'Juin' },
  { value: 7, label: 'Juillet' }, { value: 8, label: 'Août' }, { value: 9, label: 'Septembre' },
  { value: 10, label: 'Octobre' }, { value: 11, label: 'Novembre' }, { value: 12, label: 'Décembre' },
];

export const currentYear = new Date().getFullYear();
export const ANNEE_OPTIONS = Array.from({ length: 5 }, (_, i) => currentYear - 1 + i);
export const MONTH_DAY_OPTIONS = Array.from({ length: 31 }, (_, i) => i + 1);
export const DEFAULT_RELANCE_MONTH_DAYS = [28];

export const COMMERCIAUX_LUNDI_EXCLUDED_STATUTS = ['Option', 'BAT Validé', 'Rien'];
export const DEFAULT_COMMERCIAUX_LUNDI_WINDOW_DAYS = 14;
export const COMMERCIAUX_LUNDI_WINDOW_PRESETS = [7, 14, 21, 30];
export const DEFAULT_COMMERCIAUX_LUNDI_CANAUX = ['mag', 'set', 'web', 'newsletter'];

export const statutOptionValue = (statut) => {
  if (typeof statut === 'string') return statut.trim();
  return String(statut?.value || statut?.label || statut?.name || '').trim();
};

export const defaultCommerciauxLundiStatuts = (statuts = []) => (
  (statuts || [])
    .map(statutOptionValue)
    .filter(Boolean)
    .filter((value) => value !== '—' && !COMMERCIAUX_LUNDI_EXCLUDED_STATUTS.includes(value))
);

export const normalizeCommerciauxLundiWindowDays = (value) => {
  const days = Number(value);
  if (!Number.isFinite(days) || days < 1) return DEFAULT_COMMERCIAUX_LUNDI_WINDOW_DAYS;
  return Math.min(90, Math.round(days));
};

export const DEFAULT_CRON_NAMES = {
  cdf_dispo_mag: 'Alerte de disponibilité sur tous les supports',
  media_planning: 'Alerte par statut sur tous les supports',
  audience_semaine: 'Audiences pubs de la semaine',
  commerciaux_lundi: 'Point des ventes des commerciaux',
  klub_etapes_lundi: 'Étapes Klub en cours',
  pub_graphiste: 'Alerte de pub en retard',
  mails_clients_mag_set: 'Relances des clients MAG / SET',
  relance_vente_n1: 'Relance renouvellement vente N-1',
  pense_bete_codir: 'Pense bête — 15/5 CODIR',
  clients_annuaire_sync: 'Synchro annuaire clients',
  web_audience_sync: 'Synchro audience web',
  newsletter_audience_sync: 'Synchro audience newsletter',
  hebergement_mainwp_import: 'Import sites MainWP',
  bat_valide: 'BAT validé',
  nl_vendu: 'Newsletter — Vendu',
  nl_bat_valide: 'Newsletter — BAT validé',
};

export const DEFAULT_PENSE_BETE_MESSAGE = `Hello à tous,

Un pti mail pour que vous pensiez à remplir vos 15/5 !

Bonne journée,`;

export const CRON_TYPE_UI = {
  cdf_dispo_mag: {
    icon: 'mdi:newspaper-variant-outline',
    color: '#e30613',
    blurb: 'Prévenir quand il reste de la place le mois prochain.',
  },
  media_planning: {
    icon: 'mdi:filter-variant',
    color: '#2563eb',
    blurb: 'Suivre les dossiers selon leur statut. Sans mois : M+1, puis M+2 après la date butoir.',
  },
  audience_semaine: {
    icon: 'mdi:chart-box-outline',
    color: '#7c3aed',
    blurb: 'Recevoir le récap des audiences pubs de la semaine.',
  },
  commerciaux_lundi: {
    icon: 'mdi:account-tie',
    color: '#0f766e',
    blurb: 'Point des ventes de chaque commercial.',
  },
  klub_etapes_lundi: {
    icon: 'mdi:clipboard-check-outline',
    color: '#0f766e',
    blurb: 'Chaque responsable reçoit ses étapes ouvertes sur les sites Klub en cours.',
  },
  pub_graphiste: {
    icon: 'mdi:palette-outline',
    color: '#c2410c',
    blurb: 'Prévenir quand une pub est en retard.',
  },
  mails_clients_mag_set: {
    icon: 'mdi:email-multiple-outline',
    color: '#db2777',
    blurb: 'Relancer les clients MAG / SET qui doivent envoyer leur visuel.',
  },
  relance_vente_n1: {
    icon: 'mdi:restore',
    color: '#ca8a04',
    blurb: 'Rappel N-1 sur M+2. Après la date butoir du mois, ça passe à M+3.',
  },
  pense_bete_codir: {
    icon: 'mdi:lightbulb-on-outline',
    color: '#4f46e5',
    blurb: 'Petit rappel pour remplir les 15/5 CODIR.',
  },
  clients_annuaire_sync: {
    icon: 'mdi:account-sync-outline',
    color: '#0f766e',
    blurb: 'Mise à jour quotidienne de l’annuaire clients.',
  },
  web_audience_sync: {
    icon: 'mdi:wordpress',
    color: '#059669',
    blurb: 'Mise à jour quotidienne des stats pubs web.',
  },
  newsletter_audience_sync: {
    icon: 'mdi:email-sync-outline',
    color: '#7c3aed',
    blurb: 'Mise à jour quotidienne des stats newsletter.',
  },
  hebergement_mainwp_import: {
    icon: 'mdi:cloud-download-outline',
    color: '#0369a1',
    blurb: 'Import quotidien des sites web depuis MainWP, puis auto-lien des fiches vides.',
  },
  bat_valide: {
    icon: 'mdi:check-decagram-outline',
    color: '#15803d',
    blurb: 'Mail au commercial dès qu’une pub passe en BAT Validé.',
  },
  nl_vendu: {
    icon: 'mdi:email-check-outline',
    color: '#7c3aed',
    blurb: 'Prévenir les personnes choisies dès qu’une newsletter passe en Vendu.',
  },
  nl_bat_valide: {
    icon: 'mdi:file-check-outline',
    color: '#6d28d9',
    blurb: 'Prévenir les personnes choisies, avec les fichiers, dès qu’une newsletter passe en BAT Validé.',
  },
};

export const SCHEDULE_PRESETS_WEEKLY = [
  { id: 'lundi9', label: 'Tous les lundis à 9h', hint: 'Le plus courant', weekdays: [1], hour: 9, minute: 0 },
  { id: 'matins8', label: 'Tous les matins (lun–ven) à 8h', hint: 'En semaine', weekdays: [1, 2, 3, 4, 5], hour: 8, minute: 0 },
  { id: 'tous9', label: 'Tous les jours à 9h', hint: 'Week-end compris', weekdays: [1, 2, 3, 4, 5, 6, 7], hour: 9, minute: 0 },
  { id: 'custom', label: 'Choisir d’autres jours ou une autre heure', weekdays: null },
];

export const SCHEDULE_PRESETS_MONTH = [
  { id: '1', label: 'Le 1er du mois', monthDays: [1] },
  { id: '1-15', label: 'Le 1er et le 15', monthDays: [1, 15] },
  { id: '28', label: 'Le 28 du mois', monthDays: [28] },
  { id: 'custom', label: 'Choisir d’autres jours', monthDays: null },
];

export const HOUR_PRESETS = [
  { label: '5h', hour: 5, minute: 0 },
  { label: '6h', hour: 6, minute: 0 },
  { label: '8h', hour: 8, minute: 0 },
  { label: '9h', hour: 9, minute: 0 },
  { label: '10h', hour: 10, minute: 0 },
  { label: '12h', hour: 12, minute: 0 },
  { label: '14h', hour: 14, minute: 0 },
  { label: '17h', hour: 17, minute: 0 },
];

export const WIZARD_STEPS = [
  {
    id: 'quoi',
    title: 'Type de mail',
    question: 'Quel type de mail voulez-vous envoyer ?',
    hint: '',
  },
  {
    id: 'quand',
    title: 'Date d’envoi',
    question: 'Quand faut-il l’envoyer ?',
    hint: '',
  },
  {
    id: 'qui',
    title: 'Destinataire',
    question: 'Qui doit recevoir ce mail ?',
    hint: '',
  },
  {
    id: 'statuts',
    title: 'Statuts',
    question: 'Pour quels statuts de dossiers ?',
    hint: 'Le mail ne parlera que des dossiers dans ces statuts.',
  },
];

export const isSystemCronType = (cronType) => (
  cronType === 'clients_annuaire_sync'
  || cronType === 'web_audience_sync'
  || cronType === 'newsletter_audience_sync'
  || cronType === 'hebergement_mainwp_import'
);

export const isInstantCronType = (cronType) => (
  cronType === 'bat_valide' || cronType === 'nl_vendu' || cronType === 'nl_bat_valide'
);

export const isInstantRecipientsCronType = (cronType) => (
  cronType === 'nl_vendu' || cronType === 'nl_bat_valide'
);

export const instantCronTriggerLabel = (cronType) => {
  if (cronType === 'nl_vendu') return 'Passage à Vendu';
  if (cronType === 'nl_bat_valide') return 'Passage à BAT Validé';
  return 'Passage à BAT Validé';
};

export const hasCronTestMode = (cronType) => (
  cronType === 'commerciaux_lundi'
  || cronType === 'mails_clients_mag_set'
  || cronType === 'klub_etapes_lundi'
);

export const defaultCronName = (cronType, cronTypes = []) => (
  DEFAULT_CRON_NAMES[cronType]
  || cronTypes.find((t) => t.id === cronType)?.label
  || ''
);

const COPY_PREFIX_RE = /^Copie de\s+/i;
const COPY_SUFFIX_RE = /\s*\((\d+)\)\s*$/;

export const cronNameStem = (name) => (
  String(name || '')
    .trim()
    .replace(COPY_PREFIX_RE, '')
    .replace(COPY_SUFFIX_RE, '')
    .trim()
);

export const nextDuplicateCronName = (sourceName, crons = []) => {
  const stem = cronNameStem(sourceName) || String(sourceName || '').trim();
  const taken = new Set(
    (crons || [])
      .map((cron) => String(cron?.name || '').trim().toLowerCase())
      .filter(Boolean),
  );
  let n = 1;
  while (taken.has(`${stem} (${n})`.toLowerCase())) {
    n += 1;
  }
  return `${stem} (${n})`;
};

export const emptyFilters = () => ({
  canaux: ['mag', 'set', 'web', 'newsletter'],
  annee: currentYear,
  mois: [],
  commercial_id: '',
  format: [],
  contenu: [],
  statut_phase: ['Option'],
  search: '',
  test_mode: false,
  test_email: '',
  commercial_ids: [],
  message_body: '',
  month_days: [...DEFAULT_RELANCE_MONTH_DAYS],
  period_mode: 'auto',
  window_days: DEFAULT_COMMERCIAUX_LUNDI_WINDOW_DAYS,
  only_own_commercial_lines: false,
  week_interval: 1,
  week_anchor: '',
});

export const emptyForm = (cronType = 'cdf_dispo_mag', cronTypes = [], options = {}) => {
  const testEmail = String(options.testEmail || '').trim();
  const filters = emptyFilters();
  if (cronType === 'pense_bete_codir') {
    filters.message_body = DEFAULT_PENSE_BETE_MESSAGE;
  }
  if (cronType === 'commerciaux_lundi') {
    filters.statut_phase = [];
    filters.period_mode = 'auto';
    filters.window_days = DEFAULT_COMMERCIAUX_LUNDI_WINDOW_DAYS;
    filters.canaux = [...DEFAULT_COMMERCIAUX_LUNDI_CANAUX];
  }
  if (hasCronTestMode(cronType) && options.defaultTestMode !== false) {
    filters.test_mode = true;
    filters.test_email = testEmail;
  }
  return {
    name: defaultCronName(cronType, cronTypes),
    cron_type: cronType,
    weekday: 1,
    weekdays: [1],
    hour: cronType === 'clients_annuaire_sync' ? 5 : (isSystemCronType(cronType) ? 6 : 9),
    minute: 0,
    recipient_user_ids: [],
    extra_emails: '',
    filters,
  };
};

export const cronToForm = (cron, cronTypes = []) => {
  const weekdaysFromCron = (cron.weekdays || cron.filters?.weekdays || [cron.weekday || 1])
    .map(Number)
    .filter((d) => d >= 1 && d <= 7);
  const weekdays = weekdaysFromCron.length > 0
    ? [...new Set(weekdaysFromCron)].sort((a, b) => a - b)
    : [1];
  const cronType = cron.cron_type ?? 'cdf_dispo_mag';
  const extraEmails = Array.isArray(cron.extra_emails)
    ? cron.extra_emails.join(', ')
    : String(cron.extra_emails || '');

  return {
    name: (cron.name ?? '').trim() || defaultCronName(cronType, cronTypes),
    cron_type: cronType,
    weekday: weekdays[0],
    weekdays,
    hour: cron.hour != null && cron.hour !== '' ? Number(cron.hour) : 9,
    minute: cron.minute != null && cron.minute !== '' ? Number(cron.minute) : 0,
    recipient_user_ids: (cron.recipient_user_ids ?? []).map(Number),
    extra_emails: extraEmails,
    filters: {
      ...emptyFilters(),
      ...(cron.filters || {}),
      commercial_ids: (cron.filters?.commercial_ids || []).map(Number).filter((id) => id > 0),
      test_mode: Boolean(cron.filters?.test_mode),
      test_email: cron.filters?.test_email || '',
      statut_phase: (cron.filters?.statut_phase || []).length > 0
        ? cron.filters.statut_phase
        : (cronType === 'media_planning' ? ['Option'] : []),
      only_own_commercial_lines: Boolean(cron.filters?.only_own_commercial_lines),
      period_mode: cron.filters?.period_mode === 'custom' ? 'custom' : 'auto',
      window_days: normalizeCommerciauxLundiWindowDays(cron.filters?.window_days),
      message_body: cron.filters?.message_body
        || (cronType === 'pense_bete_codir' ? DEFAULT_PENSE_BETE_MESSAGE : ''),
      week_interval: normalizeWeekInterval(cron.filters?.week_interval),
      week_anchor: normalizeWeekAnchor(cron.filters?.week_anchor),
      month_days: (cron.filters?.month_days || DEFAULT_RELANCE_MONTH_DAYS)
        .map(Number)
        .filter((d) => d >= 1 && d <= 31)
        .sort((a, b) => a - b),
      weekdays,
    },
  };
};

export const getCronTypeUi = (cronType) => (
  CRON_TYPE_UI[cronType] || {
    icon: 'mdi:email-outline',
    color: '#334155',
    blurb: '',
  }
);

const sortedJoin = (values) => [...(values || [])].map(Number).sort((a, b) => a - b).join(',');

export const matchWeeklyPreset = (weekdays) => {
  const key = sortedJoin(weekdays);
  const found = SCHEDULE_PRESETS_WEEKLY.find((preset) => (
    preset.weekdays && sortedJoin(preset.weekdays) === key
  ));
  return found?.id || 'custom';
};

export const matchMonthPreset = (monthDays) => {
  const key = sortedJoin(monthDays);
  const found = SCHEDULE_PRESETS_MONTH.find((preset) => (
    preset.monthDays && sortedJoin(preset.monthDays) === key
  ));
  return found?.id || 'custom';
};

export const formatWeekdaysLabel = (weekdays) => {
  const days = [...new Set((weekdays || []).map(Number).filter((d) => d >= 1 && d <= 7))]
    .sort((a, b) => a - b);
  if (days.length === 0) return '';
  if (days.length === 7) return 'Tous les jours';
  if (sortedJoin(days) === '1,2,3,4,5') return 'Du lundi au vendredi';
  if (days.length === 1) {
    const label = WEEKDAY_OPTIONS.find((d) => d.value === days[0])?.label || '';
    return label ? `Tous les ${label.toLowerCase()}s` : '';
  }
  const labels = days.map((value) => WEEKDAY_OPTIONS.find((d) => d.value === value)?.label?.toLowerCase());
  if (labels.length === 2) return `Les ${labels[0]}s et ${labels[1]}s`;
  return `Les ${labels.slice(0, -1).join(', ')}s et ${labels[labels.length - 1]}s`;
};

export const formatMonthDaysLabel = (monthDays) => {
  const days = [...new Set((monthDays || []).map(Number).filter((d) => d >= 1 && d <= 31))]
    .sort((a, b) => a - b);
  if (days.length === 0) return '';
  if (sortedJoin(days) === '1') return 'Le 1er du mois';
  if (sortedJoin(days) === '1,15') return 'Les 1er et 15 du mois';
  const pretty = days.map((day) => (day === 1 ? '1er' : String(day)));
  if (pretty.length === 1) return `Le ${pretty[0]} du mois`;
  if (pretty.length === 2) return `Les ${pretty[0]} et ${pretty[1]} du mois`;
  return `Les ${pretty.slice(0, -1).join(', ')} et ${pretty[pretty.length - 1]} du mois`;
};

export const formatTimeLabel = (hour, minute) => {
  const h = Number(hour);
  const m = Number(minute);
  if (!Number.isFinite(h)) return '';
  if (!m) return `${h}h`;
  return `${h}h${String(m).padStart(2, '0')}`;
};

export const normalizeWeekInterval = (value) => (Number(value) === 2 ? 2 : 1);

export const normalizeWeekAnchor = (value) => {
  const text = String(value || '').trim();
  if (!/^\d{4}-\d{2}-\d{2}$/.test(text)) return '';
  const [year, month, day] = text.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
    return '';
  }
  return text;
};

export const isoWeekdayFromDate = (date) => (date.getDay() === 0 ? 7 : date.getDay());

export const weekAnchorWeekday = (anchor) => {
  const normalized = normalizeWeekAnchor(anchor);
  if (!normalized) return null;
  const [year, month, day] = normalized.split('-').map(Number);
  return isoWeekdayFromDate(new Date(year, month - 1, day));
};

export const weekAnchorMatchesWeekdays = (anchor, weekdays) => {
  const weekday = weekAnchorWeekday(anchor);
  if (weekday == null) return false;
  return (weekdays || []).map(Number).includes(weekday);
};

const calendarDayIndex = (year, monthIndex, day) => Math.round(Date.UTC(year, monthIndex, day) / 86400000);

export const isOnBiweeklyGrid = (date, anchor) => {
  const normalized = normalizeWeekAnchor(anchor);
  if (!normalized || !(date instanceof Date) || Number.isNaN(date.getTime())) return false;
  const [year, month, day] = normalized.split('-').map(Number);
  const diff = calendarDayIndex(date.getFullYear(), date.getMonth(), date.getDate())
    - calendarDayIndex(year, month - 1, day);
  return diff >= 0 && diff % 14 === 0;
};

export const formatBiweeklyLabel = (weekdays) => {
  const days = [...new Set((weekdays || []).map(Number).filter((d) => d >= 1 && d <= 7))]
    .sort((a, b) => a - b);
  if (days.length === 1) {
    const label = WEEKDAY_OPTIONS.find((d) => d.value === days[0])?.label?.toLowerCase() || '';
    return label ? `Un ${label} sur deux` : 'Une semaine sur deux';
  }
  const base = formatWeekdaysLabel(days);
  return base ? `${base}, une semaine sur deux` : 'Une semaine sur deux';
};

export const formatSchedulePhrase = ({
  cronType,
  weekdays,
  weekdayLabel,
  hour,
  minute,
  monthDays,
  timeLabel,
  weekInterval,
  weekAnchor,
} = {}) => {
  const time = timeLabel || formatTimeLabel(hour, minute);
  if (isSystemCronType(cronType)) {
    return time ? `Tous les jours à ${time}` : 'Tous les jours';
  }
  if (cronType === 'mails_clients_mag_set') {
    return time ? `Aux dates prévues, à ${time}` : 'Aux dates prévues (1er, 15 et J-7)';
  }
  if (cronType === 'relance_vente_n1') {
    const daysLabel = formatMonthDaysLabel(monthDays);
    if (daysLabel && time) return `${daysLabel}, à ${time}`;
    return daysLabel || time || '—';
  }
  if (normalizeWeekInterval(weekInterval) === 2 && normalizeWeekAnchor(weekAnchor)) {
    const daysLabel = formatBiweeklyLabel(weekdays);
    if (daysLabel && time) return `${daysLabel} à ${time}`;
    return daysLabel || time || '—';
  }
  const daysLabel = weekdayLabel || formatWeekdaysLabel(weekdays);
  if (daysLabel && time) return `${daysLabel} à ${time}`;
  return daysLabel || time || '—';
};

export const parseExtraEmails = (value) => {
  if (Array.isArray(value)) {
    return value.map((email) => String(email || '').trim()).filter(Boolean);
  }
  return String(value || '')
    .split(/[\s,;]+/)
    .map((email) => email.trim())
    .filter(Boolean);
};

const uniqueJoin = (parts) => [...new Set(parts.filter(Boolean))];

export const formatRecipientNames = (cron, commerciaux = []) => {
  if (isSystemCronType(cron?.cron_type)) {
    return ['Pas de mail — synchro interne'];
  }
  if (cron?.cron_type === 'klub_etapes_lundi') {
    const recipientList = Array.isArray(cron.recipients) ? cron.recipients : [];
    const extraEmails = Array.isArray(cron.extra_emails) ? cron.extra_emails : [];
    const copies = [
      ...recipientList.map((recipient) => recipient.fullName || recipient.email),
      ...extraEmails,
    ].filter(Boolean);
    if (copies.length === 0) {
      return ['Chaque responsable'];
    }
    return ['Chaque responsable', ...copies.map((label) => `copie ${label}`)];
  }
  if (cron?.cron_type === 'commerciaux_lundi') {
    const selectedIds = (cron.filters?.commercial_ids || []).map(Number).filter((id) => id > 0);
    const commercialLabels = selectedIds.length === 0
      ? ['Tous les commerciaux']
      : commerciaux
        .filter((item) => selectedIds.includes(Number(item.id)))
        .map((item) => item.nom || item.name || item.fullName || `#${item.id}`);
    const recipientList = Array.isArray(cron.recipients) ? cron.recipients : [];
    const extraEmails = Array.isArray(cron.extra_emails) ? cron.extra_emails : [];
    const copies = [
      ...recipientList.map((recipient) => recipient.fullName || recipient.email),
      ...extraEmails,
    ].filter(Boolean);
    if (copies.length === 0) {
      return [...commercialLabels, 'copie Richard'];
    }
    return [...commercialLabels, ...copies.map((label) => `copie ${label}`)];
  }

  const recipientList = Array.isArray(cron.recipients) ? cron.recipients : [];
  const extraEmails = Array.isArray(cron.extra_emails) ? cron.extra_emails : [];

  return uniqueJoin([
    ...recipientList.map((recipient) => recipient.fullName || recipient.email),
    ...extraEmails,
  ]);
};

export const formatRecipientsPhrase = (names) => {
  const list = (names || []).filter(Boolean);
  if (list.length === 0) return 'Aucun destinataire';
  if (list.length === 1) return list[0];
  if (list.length === 2) return `${list[0]} et ${list[1]}`;
  if (list.length === 3) return `${list[0]}, ${list[1]} et ${list[2]}`;
  return `${list[0]}, ${list[1]} et ${list.length - 2} autres`;
};

export const formatFormRecipientNames = (form, users = [], commerciaux = []) => {
  if (form.cron_type === 'klub_etapes_lundi') {
    const copies = [
      ...users
        .filter((user) => (form.recipient_user_ids || []).map(Number).includes(Number(user.id)))
        .map((user) => formatPersonShortName(user.fullName)),
      ...parseExtraEmails(form.extra_emails),
    ];
    if (copies.length === 0) return ['Chaque responsable'];
    return ['Chaque responsable', ...copies.map((label) => `copie ${label}`)];
  }
  if (form.cron_type === 'commerciaux_lundi') {
    const selectedIds = (form.filters?.commercial_ids || []).map(Number).filter((id) => id > 0);
    const commercialLabels = selectedIds.length === 0
      ? ['Tous les commerciaux']
      : commerciaux
        .filter((item) => selectedIds.includes(Number(item.id)))
        .map((item) => formatPersonShortName(item.nom || item.name || item.fullName || item.label || `#${item.id}`));
    const copies = [
      ...users
        .filter((user) => (form.recipient_user_ids || []).map(Number).includes(Number(user.id)))
        .map((user) => formatPersonShortName(user.fullName)),
      ...parseExtraEmails(form.extra_emails),
    ];
    if (copies.length === 0) return [...commercialLabels, 'copie Richard'];
    return [...commercialLabels, ...copies.map((label) => `copie ${label}`)];
  }

  return uniqueJoin([
    ...users
      .filter((user) => (form.recipient_user_ids || []).map(Number).includes(Number(user.id)))
      .map((user) => formatPersonShortName(user.fullName)),
    ...parseExtraEmails(form.extra_emails),
  ]);
};

export const formatCommerciauxLundiFiltersPhrase = (filters = {}) => {
  const selectedCanaux = (filters.canaux || []).filter((id) => (
    DEFAULT_COMMERCIAUX_LUNDI_CANAUX.includes(id)
  ));
  const canaux = selectedCanaux.length > 0 ? selectedCanaux : DEFAULT_COMMERCIAUX_LUNDI_CANAUX;
  const canalLabels = canaux
    .map((id) => CANAUX_OPTIONS.find((canal) => canal.id === id)?.label)
    .filter(Boolean);
  const parts = [canalLabels.join(', ') || 'Tous les supports'];

  if (filters.period_mode === 'custom') {
    const mois = [...(filters.mois || [])].map(Number).filter((m) => m >= 1 && m <= 12).sort((a, b) => a - b);
    const moisLabels = mois.map((value) => MOIS_OPTIONS.find((item) => item.value === value)?.label).filter(Boolean);
    const annee = Number(filters.annee) || currentYear;
    if (moisLabels.length > 0) {
      parts.push(moisLabels.length === 1
        ? `${moisLabels[0]} ${annee}`
        : `${moisLabels.join(', ')} ${annee}`);
    } else {
      parts.push(`année ${annee}`);
    }
  } else {
    parts.push('période auto');
  }

  if (canaux.some((id) => id === 'web' || id === 'newsletter')) {
    parts.push(`${normalizeCommerciauxLundiWindowDays(filters.window_days)} j. WEB/NL`);
  }

  const statuts = (filters.statut_phase || []).map((s) => String(s || '').trim()).filter(Boolean);
  parts.push(statuts.length > 0 ? `${statuts.length} statut${statuts.length > 1 ? 's' : ''}` : 'hors Option / BAT Validé');

  return parts.join(' · ');
};

export const formatMediaPlanningFiltersPhrase = (filters = {}) => {
  const selectedCanaux = (filters.canaux || []).filter((id) => (
    CANAUX_OPTIONS.some((canal) => canal.id === id)
  ));
  const canaux = selectedCanaux.length > 0 ? selectedCanaux : CANAUX_OPTIONS.map((c) => c.id);
  const canalLabels = canaux
    .map((id) => CANAUX_OPTIONS.find((canal) => canal.id === id)?.label)
    .filter(Boolean);
  const parts = [canalLabels.join(', ') || 'Tous les supports'];

  const mois = [...(filters.mois || [])].map(Number).filter((m) => m >= 1 && m <= 12).sort((a, b) => a - b);
  if (mois.length > 0) {
    const moisLabels = mois.map((value) => MOIS_OPTIONS.find((item) => item.value === value)?.label).filter(Boolean);
    const annee = Number(filters.annee) || currentYear;
    parts.push(moisLabels.length === 1
      ? `${moisLabels[0]} ${annee}`
      : `${moisLabels.join(', ')} ${annee}`);
  } else {
    parts.push('période auto');
  }

  const statuts = (filters.statut_phase || []).map((s) => String(s || '').trim()).filter(Boolean);
  if (statuts.length === 0) {
    parts.push('statut Option');
  } else if (statuts.length <= 3) {
    parts.push(statuts.join(', '));
  } else {
    parts.push(`${statuts.length} statuts`);
  }

  if (filters.only_own_commercial_lines) {
    parts.push('lignes du destinataire');
  }

  return parts.join(' · ');
};

export const buildAutoName = (form, users = [], cronTypes = [], commerciaux = []) => {
  const typeLabel = defaultCronName(form.cron_type, cronTypes);
  const people = formatFormRecipientNames(form, users, commerciaux)
    .filter((label) => !String(label).startsWith('copie '))
    .filter((label) => label !== 'Tous les commerciaux' && label !== 'Chaque responsable');
  const firstPerson = people[0] ? formatPersonShortName(people[0]) : '';
  const extraCount = Math.max(0, people.length - 1);
  const peoplePart = firstPerson
    ? (extraCount > 0 ? `${firstPerson} +${extraCount}` : firstPerson)
    : '';
  const schedule = formatSchedulePhrase({
    cronType: form.cron_type,
    weekdays: form.weekdays,
    hour: form.hour,
    minute: form.minute,
    monthDays: form.filters?.month_days,
    weekInterval: form.filters?.week_interval,
    weekAnchor: form.filters?.week_anchor,
  });
  return [typeLabel, peoplePart, schedule].filter(Boolean).join(' — ');
};

export const computeNextRunAt = ({
  cronType,
  weekdays,
  hour,
  minute,
  monthDays,
  weekInterval,
  weekAnchor,
  from = new Date(),
} = {}) => {
  const h = Number.isFinite(Number(hour)) ? Number(hour) : 9;
  const m = Number.isFinite(Number(minute)) ? Number(minute) : 0;

  if (cronType === 'relance_vente_n1') {
    const days = [...new Set((monthDays || DEFAULT_RELANCE_MONTH_DAYS).map(Number))]
      .filter((day) => day >= 1 && day <= 31);
    return nextMatchingDate(from, h, m, (date) => days.includes(date.getDate()), 62);
  }

  const days = cronType === 'mails_clients_mag_set' || isSystemCronType(cronType)
    ? [1, 2, 3, 4, 5, 6, 7]
    : [...new Set((weekdays || [1]).map(Number))].filter((day) => day >= 1 && day <= 7);
  const biweekly = normalizeWeekInterval(weekInterval) === 2 && Boolean(normalizeWeekAnchor(weekAnchor));

  return nextMatchingDate(from, h, m, (date) => {
    const iso = isoWeekdayFromDate(date);
    if (!days.includes(iso)) return false;
    if (!biweekly) return true;
    return isOnBiweeklyGrid(date, weekAnchor);
  }, biweekly ? 400 : 8);
};

const nextMatchingDate = (from, hour, minute, predicate, horizonDays) => {
  for (let add = 0; add <= horizonDays; add += 1) {
    const date = new Date(from);
    date.setDate(from.getDate() + add);
    date.setHours(hour, minute, 0, 0);
    if (predicate(date) && date.getTime() > from.getTime()) {
      return date;
    }
  }
  return null;
};

const capitalize = (value) => {
  const text = String(value || '');
  if (!text) return '';
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const formatNextRunLabel = (date) => {
  if (!date) return '—';
  return capitalize(date.toLocaleString('fr-FR', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    hour: '2-digit',
    minute: '2-digit',
  }));
};

export const formatLastRunLabel = (iso) => {
  if (!iso) return 'Jamais envoyé';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return 'Jamais envoyé';
  const now = new Date();
  const time = date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startOfDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const dayDiff = Math.round((startOfToday - startOfDate) / 86400000);
  if (dayDiff === 0) return `aujourd’hui à ${time}`;
  if (dayDiff === 1) return `hier à ${time}`;
  return date.toLocaleString('fr-FR', {
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const cronMatchesSearch = (cron, query, commerciaux = []) => {
  const q = String(query || '').trim().toLowerCase();
  if (!q) return true;
  const haystack = [
    cron.name,
    cron.cron_type_label,
    cron.cron_type,
    cron.created_by_label,
    cron.weekday_label,
    cron.time_label,
    ...(Array.isArray(cron.recipients) ? cron.recipients : []).flatMap((recipient) => [recipient.fullName, recipient.email]),
    ...(Array.isArray(cron.extra_emails) ? cron.extra_emails : []),
    ...formatRecipientNames(cron, commerciaux),
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
  return haystack.includes(q);
};

export const findDuplicateCrons = (crons, cronType, editingId) => (
  (crons || []).filter((cron) => (
    cron.cron_type === cronType && Number(cron.id) !== Number(editingId)
  ))
);

export const findOverlappingDuplicates = (duplicates, form) => {
  const myUsers = new Set((form.recipient_user_ids || []).map(Number));
  const myEmails = new Set(parseExtraEmails(form.extra_emails).map((email) => email.toLowerCase()));
  return (duplicates || []).filter((cron) => {
    const theirUsers = (cron.recipient_user_ids || []).map(Number);
    const theirEmails = parseExtraEmails(cron.extra_emails).map((email) => email.toLowerCase());
    return theirUsers.some((id) => myUsers.has(id))
      || theirEmails.some((email) => myEmails.has(email));
  });
};
